/** Canonical maneuver event type for API queries and global store (uppercase, default TACK). */
export function normalizeManeuverEventType(value: string | null | undefined): string {
  const normalized = (value ?? 'TACK').trim().toUpperCase();
  return normalized || 'TACK';
}

/**
 * Single-letter `Maneuver_type` (as stored on map/track rows) → canonical event type.
 *
 * Written by `identifyManeuvers` in libs/utilities/utilities/race_utils.py: every type uses its
 * own first letter EXCEPT takeoff, which is 'A' because 'T' already belongs to TACK.
 */
const MANEUVER_LETTER_TO_EVENT_TYPE: Record<string, string> = {
  T: 'TACK',
  G: 'GYBE',
  R: 'ROUNDUP',
  B: 'BEARAWAY',
  A: 'TAKEOFF',
};

/**
 * Maneuver event types a tag write targets when the page has no single type selected.
 *
 * Deliberately excludes TAKEOFF: the grade hotkeys were only ever offered on the four turning
 * types, and a tag write is scoped to the types it names.
 */
export const MANEUVER_EVENT_TYPES = ['TACK', 'GYBE', 'BEARAWAY', 'ROUNDUP'];

/** Every event type a map maneuver marker can stand for. */
export const MANEUVER_MARKER_EVENT_TYPES: string[] = Object.values(MANEUVER_LETTER_TO_EVENT_TYPE);

/** Resolve a marker's `Maneuver_type` letter to its event type, or null when the letter is unknown. */
export function maneuverLetterToEventType(letter: string | null | undefined): string | null {
  if (letter == null) return null;
  const key = String(letter).trim().toUpperCase();
  return MANEUVER_LETTER_TO_EVENT_TYPE[key] ?? null;
}
